import { render, staticRenderFns } from "./SyncGoogleCalendar.vue?vue&type=template&id=bc0f432e&scoped=true"
import script from "./SyncGoogleCalendar.vue?vue&type=script&lang=js"
export * from "./SyncGoogleCalendar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc0f432e",
  null
  
)

export default component.exports